import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import api from '../lib/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth } = useAuth();
  const { theme } = useTheme();
  const { t } = useLanguage();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);
    if (!sessionIdMatch) {
      navigate('/login', { replace: true });
      return;
    }

    const sessionId = sessionIdMatch[1];

    const exchangeSession = async () => {
      try {
        await api.post('/auth/google/session', { session_id: sessionId });
        await checkAuth();
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Google auth failed:', error);
        navigate('/login', { replace: true });
      }
    };

    exchangeSession();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: theme.bg }}>
      <div className="text-center space-y-4">
        <div className="w-8 h-8 mx-auto rounded-full animate-spin" style={{ border: `2px solid ${theme.border}`, borderTopColor: theme.primary }} />
        <p style={{ color: theme.textSecondary }}>{t('authenticating_google')}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
